import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModelUser } from "../../models/Model-user";
import { ModelSolicitante } from "../../models/Model-solicitante";

import Swal from 'sweetalert2';

import { throwError } from "rxjs";
import { _URL_SERVICES_BE } from './../../config/config';
@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  login(modelUser: ModelUser): Observable<any>{
    return this.http.post(
      _URL_SERVICES_BE + '/login/auth',
      JSON.stringify(modelUser),
      this.httpOptions
    );
  }

  autoLogin(strToken): Observable<any>{
    let body;
    body = {
      'strToken': strToken,
    };
    return this.http.post(
      _URL_SERVICES_BE + '/login/auto',
      body,
      this.httpOptions
    );
  }

  async solicitante(modelSolicitante: ModelSolicitante){
    this.http.post(
      _URL_SERVICES_BE + '/preregistro',
      JSON.stringify(modelSolicitante),
      this.httpOptions
    )
    .subscribe((resp: any) => {
      if (resp.intResponse == 200) {
        Swal.fire('Correcto', 'Su solicitud ha sido enviada. Revisaremos sus datos y le enviaremos una respuesta lo más pronto posible', 'success')
        return true
      } else if( resp.intResponse == 203 ){
        Swal.fire('Ya existe una solicitud creada para el mismo contacto', 'Detectamos una solicitud pre-existente para el contacto referido en la forma de solicitud, en caso de requerir más información del proceso de certificación favor de contactar al agente de Angus Mexicana con el cual lleva su caso, el registro de su solicitud será cancelado.', 'error')
        return false
      } else {
        Swal.fire('Error', 'Error al registrar la solicitud', 'error')
        return false
      }
    });
  }

  async emailSend(email, message){
    let body;
    body = {
      'strEmail': email,
      'strMessage':message
    };
    this.http.post(
      _URL_SERVICES_BE + '/usuario/password',
      body,
      this.httpOptions
    )
    .subscribe((resp: any) => {
      if (resp) {
        Swal.fire('Correcto', 'El mensaje a sido enviado correctamente', 'success')
      } else {
        Swal.fire('Error', 'Hubo un error al enviar el mensaje intente de nuevo', 'error')
      }
    });
  }

  emailSendPass(email){
    let body;
    body = {
      'strEmail': email,
    };
    this.http.post(
      _URL_SERVICES_BE + '/password',
      body,
      this.httpOptions
    )
    .subscribe((resp: any) => {
      if (resp) {
        Swal.fire('Correcto', 'El mensaje para cambiar la contraseña ha sido enviado correctamente', 'success')
      } else {
        Swal.fire('Error', 'Hubo un error al enviar el mensaje, intente de nuevo', 'error')
      }
    });
  }

  changePass(pass, token): Promise<any>{
    let body;
    let promesa = new Promise((resolve, reject) => {
      body = {
        'strPassword': pass,
        'strToken': token
      };
      this.http.put(
        _URL_SERVICES_BE + '/password',
        body,
        this.httpOptions
      )
      .subscribe((resp: any) => {
        if (resp.intResponse == 200) {
          Swal.fire('Correcto', 'Contraseña actualizada correctamente', 'success');
          setTimeout(()=>{ window.location.href = "/about" }, 2500)
          resolve(true);
        } else {
          Swal.fire('Error', 'Error al actualizar la contraseña', 'error');
          reject();
        }
      });
    })
    return promesa;
  }

  getTipoUnidadProductiva():Promise<any> {
    return this.http.get(_URL_SERVICES_BE + '/ganadera/tipo').toPromise();
  }

  handleError(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  //Noticias
  getInformacionNoticia(intIdNoticia): Observable<any> {
    return this.http.get(`${_URL_SERVICES_BE}/noticia/${intIdNoticia}`)
  }
  getNoticiasLista(): Observable<any> {
    return this.http.get(`${_URL_SERVICES_BE}/noticia/lista`)
  }


}
